import axios from "axios";
import * as moment from "moment";

import { EmployeeRecord } from "./model";

class EmployeeRecordApi {

    public async getAll(employeeRecordIds: string[]): Promise<EmployeeRecord[]> {
        const response = await axios.post("/api/employeeRecord/GetAll", { employeeRecordIds });
        return response.data.map(this.parseModel);
    }

    public parseModel(model: EmployeeRecord): EmployeeRecord {
        return {
            ...model,
            dateOfBirth: model.dateOfBirth && moment(model.dateOfBirth)
        };
    }
}

export default new EmployeeRecordApi();
